/**
 * API layer địa điểm — danh sách tỉnh/huyện/xã phục vụ filter và form.
 */
import { apiClient } from '../../../shared/services/apiClient';
import { API_ROUTES } from '../../../shared/constants/apiRoutes';

/** Các hàm gọi API địa điểm. */
export const locationApi = {
  /** Lấy cây địa điểm đầy đủ. */
  getLocations: () => apiClient.get(API_ROUTES.locations),
};
